
import { computed, defineComponent, ref } from 'vue'
import { useProject } from '../hooks/useProject'
import { useHoliday } from '../hooks/useHoliday'
import useRouter from '@root/src/hooks/useRouter'

export default defineComponent({
    components: {},
    setup(props, context) {
        const { project } = useProject()
        const { holiday } = useHoliday()
        const router = useRouter()

        const mainLogo = computed(() => {
            if (holiday.value === 'NEW_YEAR') return require('@/assets/Logo_new_year.svg')
            if (holiday.value === 'VALENTINES_DAY') return require('@/assets/Logo_valentines_day.svg')
            if (holiday.value === '23_FEBRUARY') return require('@/assets/Logo_23_february.png')
            if (holiday.value === '8_MARCH') return require('@/assets/Logo_8_march.svg')
            return require('@/assets/Logo_light.svg')
        })

        /*        const mainLogo = computed(() =>
            props.isNewYear ? require('@/assets/Logo_new_year.svg') : require('@/assets/Logo_light.svg')
        ) */
        const partnerLogo = computed(() => {
            const projectPartneredWith = project.value?.settings?.partneredWith
            if (!projectPartneredWith) return null
            if (projectPartneredWith === 'loreal') return require('@/assets/img/partner-logo/loreal.svg')
            if (projectPartneredWith === 'matrix') return require('@/assets/img/partner-logo/matrix.png')
        })

        const marketEnabled = false
        const marketLogo = require('@/assets/icons/marketplace-icon.svg')
        const toMarket = () => {
            if (router.route.value.path.startsWith('/project') && router.route.value.params.id) {
                router.router.push(`/project/${router.route.value.params.id}/marketplace`)
            } else {
                router.router.push('/marketplace')
            }
        }

        return { mainLogo, partnerLogo, project, marketEnabled, marketLogo, toMarket }
    },
})
